import memoize from "@-/com.npmjs.memoize";
import type { GraphemeReadings } from "@-/dev.improve.haniverse.lib.level";
import { getSimplifiedWordReadings } from "#get-simplified-word-readings";
import { getTraditionalWordReadings } from "#get-traditional-word-readings";

const getGraphemeReadingsByGrapheme = memoize(
  (script: "simplified" | "traditional"): ReadonlyMap<string, GraphemeReadings> =>
    new Map(
      (script === "traditional" ? getTraditionalWordReadings() : getSimplifiedWordReadings()).map(
        (readings) => [readings.grapheme, readings],
      ),
    ),
);

/**
 * The studied readings of a character with several pronunciation cards, as the selected
 * script's words curriculum introduces them; undefined for a single-reading character.
 */
export function getGraphemeReadings(
  script: "simplified" | "traditional",
  grapheme: string,
): GraphemeReadings | undefined {
  return getGraphemeReadingsByGrapheme(script).get(grapheme);
}
